import { Globe2, BadgeCheck, Briefcase, Bot, Users } from "lucide-react";

const highlights = [
  { icon: Globe2, label: "Pan-India & Global Reach" },
  { icon: BadgeCheck, label: "ISO & MSME Certified" },
  { icon: Briefcase, label: "IT & Non-IT Expertise" },
  { icon: Bot, label: "AI-Powered Screening Tools" },
  { icon: Users, label: "Dedicated Account Managers" },
];

export default function About() {
  return (
    <section id="about" className="py-20 lg:py-28 relative" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-3xl overflow-hidden aspect-square border border-border shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=900&auto=format&fit=crop&q=80"
                alt="Recruitment team meeting"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-4 -right-4 hidden md:flex h-24 w-24 rounded-2xl bg-bee-honey items-center justify-center font-display text-3xl font-extrabold text-bee-teal-dark shadow-lg rotate-3">
              5+
              <span className="absolute -bottom-2 right-2 text-[10px] uppercase tracking-widest font-semibold">years</span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.2em] text-bee-orange font-semibold mb-4">About Us</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
              We don&apos;t just fill roles.
              <br />
              <span className="text-bee-teal">We build futures.</span>
            </h2>
            <div className="mt-6 space-y-4 text-base lg:text-lg text-muted-foreground max-w-2xl leading-relaxed">
              <p>
                WorkingBees Global is a dedicated recruitment and IT consulting firm helping
                businesses across India and the world find the right talent. We bring together
                people, technology, and expertise to deliver hiring that actually works.
              </p>
              <p>
                We are proud to be <b className="text-foreground">ISO Certified</b> and{" "}
                <b className="text-foreground">MSME Registered</b> — a reflection of our commitment
                to quality, compliance, and reliability.
              </p>
            </div>

            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              {highlights.map((h) => (
                <div
                  key={h.label}
                  data-testid={`about-highlight-${h.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="flex items-center gap-3 px-4 py-3 rounded-xl bg-secondary border border-border"
                >
                  <span className="h-9 w-9 rounded-lg bg-bee-teal/10 text-bee-teal inline-flex items-center justify-center flex-shrink-0">
                    <h.icon className="h-4 w-4" />
                  </span>
                  <span className="text-sm font-semibold">{h.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
